import { strCompare } from "@common/Common";
import { UserReadModel } from "@Alternatives/Assignments/Domain/readmodels";

export class UsersAssignerDialogViewModel
{
    closed: boolean = true;
    isSaving: boolean = false;

    name: string | null = null;
    alternativeIds: string[] = [];
    users: UserReadModel[] = [];
    tags: string[] = [];

    tag: string | null = null;
    searchPhrase: string | null = null;

    dialogTitle: string = "";

    get usersView(): UserReadModel[]
    {
        if (this.users == null)
        {
            return null;
        }

        let view = [... this.users];

        if (this.searchPhrase)
        {
            const phrase = this.searchPhrase.toLowerCase();
            view = view.filter(a => (`${a.Name} ${a.Email}`).toLowerCase().indexOf(phrase) > -1);
        }

        if (this.tag)
        {
            view = view.filter(a => a.Tags.indexOf(this.tag) > -1);
        }

        view = view.sort((a, b) => strCompare(a.Name.toLowerCase(), b.Name.toLowerCase()));

        return view;
    }

    show(alternativeIds: string[], users: UserReadModel[], tags: string[])
    {
        this.isSaving = false;

        this.alternativeIds = alternativeIds;
        this.tags = tags;

        users.forEach(u => u.IsUiSelected = false);
        this.users = [...users];

        this.closed = false;
    }

    close()
    {
        this.alternativeIds = [];
        this.closed = true;
    }
}

export class AssignUsersEventPayload
{
    AlternativeIds: string[] = [];
    UserIds: number[] = [];
    constructor(alternativeIds: string[], userIds: number[])
    {
        this.AlternativeIds = alternativeIds;
        this.UserIds = userIds;
    }
}

